import React from "react"
import  MainCP from "../../../Components/apruebo-rechazo/apruebo-rechazov2/MainCP"

const ViewAprueboV2: React.FC = () => <MainCP/>
export default ViewAprueboV2;